//cs stands for classSet and concats classes and modifier
const cs = (className, modifiers) =>
  className
    ? [
        className,
        ...(Array.isArray(modifiers) ? modifiers : [modifiers])
          .filter((modifier) => !!modifier)
          .map((modifier) => `${className}--${modifier}`)
      ].join(' ')
    : '';

export default cs;
